import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CaseCheck, CaseValidationRequest } from '@secca/shared/models/atlas/atlas-case-validation.model';
import { Observable } from 'rxjs';
import { AtlasApiService } from './atlas-api.service';

@Injectable({
  providedIn: 'root'
})
export class AtlasCaseValidationService {
  constructor(
    private http: HttpClient,
    private atlasApiService: AtlasApiService
  ) {}

  validateCase(request: CaseValidationRequest): Observable<CaseCheck[]> {
    return this.atlasApiService.withAtlasAuth(headers =>
      this.http.post<CaseCheck[]>(this.atlasApiService.buildUrl('/api/v1/case-validation'), request, { headers })
    );
  }
}
